import { BiLinkAlt } from 'react-icons/bi';

import Header from './components/Header';
import Footer from './components/Footer';

// Images
import Potentora_1 from './assets/portfolio/potentora-1.webp';
import Potentora_2 from './assets/portfolio/potentora-2.webp';
import Potentora_3 from './assets/portfolio/potentora-3.webp';
import GlobeBlock_1 from './assets/portfolio/globeblock-1.webp';
import GlobeBlock_2 from './assets/portfolio/globeblock-2.webp';
import GlobeBlock_3 from './assets/portfolio/globeblock-3.webp';
import GlobeBlock_4 from './assets/portfolio/globeblock-4.webp';

export default function App() {
    const portfolioItems = [
        {
            title: 'Potentora',
            description: 'A website designed to showcase and present information about a software company.',
            images: [ Potentora_1, Potentora_2, Potentora_3 ],
            preview: 'https://potentora.vercel.app/',
        },
        {
            title: 'Globe Block',
            description: 'A website for a Minecraft Server, providing information, staff details, and rules.',
            images: [ GlobeBlock_1, GlobeBlock_2, GlobeBlock_3, GlobeBlock_4 ],
            preview: ''
        },
    ];

    return (
        <>
          <Header />
          <div>
            <div className="container">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-8 gap-6">
                    {portfolioItems.map((item, idx) => (
                      <GalleryItem key={idx} item={item} index={idx} />
                    ))}
                </div>
            </div>
          </div>
          <Footer />
        </>
    );
}

function GalleryItem({ item, index }) {
  return (
    <div className="bg-white p-5 rounded-[20px]">
      <GalleryImages item={item} index={index} />

      <div className="mt-5">
        {item.preview !== '' ? (
          <div className='flex items-center space-x-1'>
            <h6 className="text-xl font-bold">
              <a href={item.preview} className="text-bg hover:text-secondary transition" target="_blank" rel="noreferrer">
                {item.title}
              </a>
            </h6>

            <BiLinkAlt className='text-xl text-slate-500' />
          </div>
        ) : (
          <h6 className="text-xl font-bold text-bg">
            {item.title}
          </h6>
        )}

        <p className="mt-1 text-slate-500">
          {item.description}
        </p>
      </div>
    </div>
  );
}

function GalleryImages({ item, index }) {
  return (
    <>
      <a data-fancybox={`gallery-${index}`} href={item.images[0]}>
        <img src={item.images[0]} alt={item.title} className="rounded" />
      </a>
      {item.images.slice(1).map((image, idx) => (
        <a key={idx} data-fancybox={`gallery-${index}`} href={image}>

        </a>
      ))}
    </>
  );
}
